<template>
  <IQOS enabled required :title="$t('integrations.poster_sync.title')">
    <SlideToggleRow
      class="mt-16"
      :value="sync_options.sync_menu"
      @input="(v) => changeSyncValue('sync_menu', v)"
    >
      {{ $t("integrations.poster_sync.sync_menu") }}
    </SlideToggleRow>
    <p class="qrw-paragraph-md iqos-comment mt-8">
      {{ $t('integrations.poster_sync.desc_menu') }}
    </p>
    <BaseDivider color="v1-grey-7" class="mt-16"/>
    <SlideToggleRow
      class="mt-16"
      :value="sync_options.sync_waiters"
      @input="(v) => changeSyncValue('sync_waiters', v)"
    >
      {{ $t("integrations.poster_sync.sync_waiters") }}
    </SlideToggleRow>
    <p class="qrw-paragraph-md iqos-comment mt-8">
      {{ $t('integrations.poster_sync.desc_waiters') }}
    </p>
    <BaseDivider color="v1-grey-7" class="mt-16"/>
    <SlideToggleRow
      class="mt-16"
      :value="sync_options.sync_storage"
      @input="(v) => changeSyncValue('sync_storage', v)"
    >
      {{ $t("integrations.poster_sync.sync_storage") }}
    </SlideToggleRow>
    <p class="qrw-paragraph-md iqos-comment mt-8">
      {{ $t('integrations.poster_sync.desc_storage') }}
    </p>
    <BaseDivider color="v1-grey-7" class="mt-16"/>
    <SlideToggleRow
      class="mt-16"
      :value="sync_options.sync_transactions"
      @input="(v) => changeSyncValue('sync_transactions', v)"
    >
      {{ $t("integrations.poster_sync.sync_transactions") }}
    </SlideToggleRow>
    <p class="qrw-paragraph-md iqos-comment mt-8">
      {{ $t('integrations.poster_sync.desc_transactions') }}
    </p>
  </IQOS>
</template>

<script>
import SlideToggleRow from "@/components/SlideToggleRow.vue";

export default {
  components: {
    SlideToggleRow,
  },
  data() {
    return {
      sync_options: {
        sync_menu: true,
        sync_waiters: true,
        sync_tables: true,
        sync_storage: false,
        sync_transactions: false
      },
      editing: false,
    };
  },
  methods: {
    reset() {
      this.sync_options.sync_menu = this.cafe.poster.sync_menu;
      this.sync_options.sync_waiters = this.cafe.poster.sync_waiters;
      this.sync_options.sync_tables = this.cafe.poster.sync_tables;
      this.sync_options.sync_storage = this.cafe.poster.sync_storage;
      this.sync_options.sync_transactions = this.cafe.poster.sync_transactions;
    },
    hideEditUI() {
      this.editing = false;
      this.reset();
    },
    showEditUI() {
      this.editing = true;
    },
    onEditFinish() {
      this.$store.commit("setPosterSyncOptions", this.sync_options);
      this.$store.dispatch("saveCafe");

      this.$store.dispatch("auditlog/write", {
        type: "change_poster_sync",
        payload: this.sync_options
      });

      this.editing = false;
    },
    changeSyncValue(key, value) {
      // if (!this.editing) return;

      this.sync_options[key] = value;
      this.onEditFinish();
    },
  },
  computed: {
    cafe() {
      return this.$store.state.cafe;
    },
  },
  mounted() {
    this.reset();
  },
};
</script>

<style>
</style>